import { Fragment, ReactNode } from 'react';

import {
  Modal as ChakraModal,
  ModalContent as ChakraModalContent,
  ModalOverlay,
  ModalProps as ChakraModalProps,
  Divider,
} from '@chakra-ui/react';

import { Button, Text, Box } from 'components/uikit';

interface ModalProps extends ChakraModalProps {
  transparentOverlay?: boolean;
}

const Modal = ({
  isOpen,
  onClose,
  transparentOverlay,
  trapFocus,
  children,
}: ModalProps) => {
  return (
    <ChakraModal
      isOpen={isOpen}
      onClose={onClose}
      trapFocus={trapFocus}
      motionPreset='slideInBottom'
    >
      <ModalOverlay
        backdropFilter={transparentOverlay ? undefined : 'blur(10px)'}
      />
      <ChakraModalContent
        borderColor='grey.border'
        border='1px solid'
        bgColor='grey.white'
        flexDir='column'
        w='calc(100% - 16px)'
        justifyContent='end'
      >
        {children}
      </ChakraModalContent>
    </ChakraModal>
  );
};

interface Action {
  content: ReactNode;
  onClick: () => void;
}

interface ActionModalProps extends Omit<ModalProps, 'children'> {
  title: ReactNode;
  description?: ReactNode;
  actions: Action[];
}

export function ActionModal({
  title,
  description,
  actions,
  ...props
}: ActionModalProps) {
  return (
    <Modal {...props}>
      <Box py='16px' px='8px' textAlign='center'>
        <Text fontSize={['lg', '2xl']} fontWeight='semibold'>
          {title}
        </Text>
        <Text color='grey.secondaryText' fontSize={['sm', 'md']}>
          {description}
        </Text>
      </Box>
      {actions.map(({ content, onClick }, index) => (
        <Fragment key={index}>
          <Divider />
          <Button
            fontWeight='regular'
            variant='primaryGhost'
            onClick={onClick}
            borderTopRadius={0}
            borderBottomRadius='4px'
            fontSize={['md', 'lg']}
            _notLast={{
              borderBottomRadius: 0,
            }}
          >
            {content}
          </Button>
        </Fragment>
      ))}
    </Modal>
  );
}
